import { Route, Routes, useLocation } from "react-router-dom";

import { Navigation } from "./Components/Header/Navigation/Navigation";
import { LogoBar } from "./Components/Header/LogoBar/LogoBar";
import { MainPage } from "./Pages/MainPage";
import { Contacts } from "./Pages/Contacts";
import { Articles } from "./Pages/Articles";
import { Partners } from "./Pages/Partners";
import { FooterBar } from "./Components/Footer/Footer";
import { ModalWindow } from "./Components/Modal/Modal";

import "materialize-css/dist/css/materialize.min.css";
import "materialize-css";
import { Article1 } from "./Pages/Articles/Article1";
import { Article2 } from "./Pages/Articles/Article2";
import { Article3 } from "./Pages/Articles/Article3";
import { Article4 } from "./Pages/Articles/Article4";
import { Article5 } from "./Pages/Articles/Article5";
import { Article6 } from "./Pages/Articles/Article6";
import DynamicBanner from "./Components/Header/DynamicBanner/DynamicBanner";

function App() {
  const location = useLocation();
  const background = location.state && location.state.background;
  return (
    <>
      <LogoBar />
      <Navigation />
      <DynamicBanner />
      <>
        <Routes location={background || location}>
          <Route path="/" element={<MainPage />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/article-psy1" element={<Article1 />} />
          <Route path="/article-psy2" element={<Article2 />} />
          <Route path="/article-psy3" element={<Article3 />} />
          <Route path="/article-psy4" element={<Article4 />} />
          <Route path="/article-psy5" element={<Article5 />} />
          <Route path="/article-psy6" element={<Article6 />} />
          <Route path="/contacts" element={<Contacts />}>
            <Route path="modal" element={<ModalWindow />} />
          </Route>
          <Route path="/partners" element={<Partners />}></Route>
        </Routes>
        {background && (
          <Routes>
            <Route path="/contacts/modal" element={<ModalWindow />} />
          </Routes>
        )}
      </>
      <FooterBar />
    </>
  );
}

export default App;
